import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import { ManageEmailsContextProvider } from 'src/sections/email_notifications/ManageEmailsContext';
import SystemNotifications from 'src/sections/email_notifications/SystemNotifications';
import UserInfo from 'src/sections/email_notifications/UserInfo';

const ManageEmails = () => {
  const { t } = useTranslation();
  const { height, width } = useWindowSize();

  const navbarHeight = useMemo(() => {
    if (width < 488) {
      return 300;
    } else if (width < 548 && width >= 488) {
      return 250;
    } else if (width < 1024 && width >= 548) {
      return 200;
    } else {
      return 150;
    }
  }, [width]);

  return (
    <ErrorBoundary>
      <ManageEmailsContextProvider>
        <div
          style={{
            display: 'grid',
            gridTemplateRows: `${navbarHeight}px ${height - navbarHeight}px`,
            gridTemplateColumns: '1fr',
            overflow: 'auto',
            gridTemplateAreas: `
          "navbar"
          "main"
        `,
          }}
        >
          <div className={'bg-white pb-2 mb-2 grid-area-navbar'}>
            <Navbar title={t('messagingPageTitle')} />
            <div
              className="px-4 mt-4 overflow-x-hidden"
              style={{ width: width < 1200 ? '100%' : '70%' }}
            >
              <div className={`grid gap-6 w-full ${width < 1200 ? 'grid-cols-1' : 'grid-cols-2'}`}>
                <UserInfo />
                <SystemNotifications />
              </div>
            </div>
          </div>
        </div>
      </ManageEmailsContextProvider>
    </ErrorBoundary>
  );
};

export default ManageEmails;
